import { useState } from 'react';

import { LoadingIndicator } from '@cfa/react-components';

import { cn } from '@/utils/tailwind';

interface IframeViewProps {
  /** Iframe url. */
  url?: string;
  className?: string;
  /** Accessible title for the iframe. */
  title?: string;
}

/** Simple view for documents that are rendered with iframes. */
const IframeView: React.FC<IframeViewProps> = ({ url, className, title }) => {
  const [iframeLoads, setIframeLoads] = useState(0);

  const onIframeLoad = () => {
    const updatedIframeLoads = iframeLoads + 1;
    setIframeLoads(updatedIframeLoads);
  };

  return (
    <div className={cn('mx-auto w-full p-0', className)}>
      <div className="mt-0 flex flex-col items-center">
        <iframe
          className={cn(
            'content-iframe w-full border-0',
            'h-[calc(100vh-var(--height-mobile-top-nav)-var(--height-searchbar-subheader))] md:h-[calc(100vh-var(--height-searchbar-subheader))]',
          )}
          allow="fullscreen"
          onLoad={onIframeLoad}
          src={url}
          title={title?.trim() ? title : 'Content'}
        />
        {iframeLoads === 0 && (
          <div className="absolute flex size-full items-center justify-center">
            <LoadingIndicator size="lg" variant="page" />
          </div>
        )}
      </div>
    </div>
  );
};

export default IframeView;
